import { useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { Link as RouterLink } from "@tanstack/react-router";
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { useCreateReturn } from "./useCreateReturn";
// MUI
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";

export const ReturnInvoice = ({
  invoiceNo,
  setReturnData,
  setActiveStep,
  setReturnDataOriginal,
}) => {
  const { handleSubmit, control } = useForm();
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const validationHelper = {
    invoice: { required: "Invoice is required" },
  };

  const { mutate, isSuccess, data, isFetching } = useCreateReturn();

  const handleOnSubmit = (data) => {
    mutate({
      data: { filter: { noFilter: data.invoice } },
    });
  };

  // Success Function
  const successFunc = () => {
    setReturnData(data.data.data);
    setReturnDataOriginal(data.data.data);
    setActiveStep(1);
  };
  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });
  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Enter Invoice
      </Typography>
      <Typography>Please enter an invoice number to start a return.</Typography>
      <Stack
        component="form"
        autoComplete="off"
        onSubmit={handleSubmit(handleOnSubmit)}
        direction="row"
        spacing={1}
        sx={{ pt: 2 }}
      >
        <Controller
          name="invoice"
          defaultValue={invoiceNo || ""}
          control={control}
          rules={{
            required: true,
          }}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              label="Invoice No."
              error={error !== undefined}
              helperText={error ? validationHelper.invoice[error.type] : ""}
            />
          )}
        />
        {isFetching ? (
          <>Loading..</>
        ) : (
          <Button variant="outlined" type="submit" disabled={isFetching}>
            Submit
          </Button>
        )}
      </Stack>
      <Typography variant="caption" sx={{ pt: 2 }}>
        If you receive an error stating that, "A return order has already been
        created for invoice", please check your{" "}
        <Link
          component={RouterLink}
          underline="none"
          sx={{ color: "primary.main" }}
          to="/returns/pending"
        >
          Pending Returns
        </Link>{" "}
        for duplicates.
      </Typography>
    </Box>
  );
};
